<script lang="ts">
	import { createEventDispatcher } from 'svelte'

  export let enableRewind:Boolean = true
  export let showRewind:Boolean = true
  export let enableStop:Boolean = true
  export let enablePause:Boolean = false
  export let showPause:boolean = true
  export let enablePlay:Boolean = true
  export let showPlay:Boolean = true

  const dispatch = createEventDispatcher()

  function handleRewind():void {
    dispatch('rewind')
  }

  function handleStop():void {
    dispatch('stop')
  }

  function handlePause():void {
    dispatch('pause')
  }

  function handlePlay():void {
    dispatch('play')
  }
</script>

<div class="flex justify-center bg-darkBackHigh text-darkForeHigh">
  <div class="dock-row">
    {#if showRewind}
      <button
        aria-label="Rewind"
        class="btn-darkBackHigh"
        on:click={handleRewind}
        disabled={!enableRewind}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M4 2v20h-2v-20h2zm18 0l-16 10 16 10v-20z" />
        </svg>
      </button>
    {/if}
    <button
      aria-label="Stop"
      class="btn-darkBackHigh"
      on:click={handleStop}
      disabled={!enableStop}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M2 2h20v20h-20z" />
      </svg>
    </button>
    {#if showPause}
    <button
      aria-label="Pause"
      class="btn-darkBackHigh"
      on:click={handlePause}
      disabled={!enablePause}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="m9 2v20h-6v-20z" />
        <path d="m21 2v20h-6v-20z" />
      </svg>
    </button>
    {/if}
    {#if showPlay}
      <button
        aria-label="Play"
        class="btn-darkBackHigh"
        on:click={handlePlay}
        disabled={!enablePlay}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="m3.6667 22v-20l16.667 10z" />
        </svg>
      </button>
    {/if}
  </div>
</div>
